exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ReportMetricsPerDateTable {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n}", ""]);

// exports
